import materials from '@/data/materials.json';
import { Material, MaterialCategory } from '@/models/Materials';

export class MaterialRepository {
	private data: Material[] = materials as Material[];

	findAll(): Material[] {
		return this.data;
	}

	findByCategory(category: MaterialCategory): Material[] {
		return this.data.filter((m) => m.category === category);
	}

	findById(id: string): Material | undefined {
		return this.data.find((m) => m.id === id);
	}

	findByName(name: string): Material | undefined {
		return this.data.find((m) => m.name.toLowerCase() === name.toLowerCase());
	}
}
